
// user module
export const SET_TOKEN = 'setToken'
export const SET_UID = 'setUid'
export const SET_USERINFO = 'setUserinfo'
export const AUTOLOGIN = 'autoLogin'
export const LOGOUT = 'logout'
export const SECONDVERIFY = 'secondverify'

// global module
export const CHANGE_NETWORK = 'changeNetwork'
